import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';
import {ICGSTCategory} from 'app/blocks/model/cgst-category.model';
import {IGSTCategory} from 'app/blocks/model/igst-category.model';
import {IgstCategoryService} from 'app/blocks/service/api/igst-category.service';

@Injectable({
    providedIn: 'root'
})
export class IGSTCategoryResource extends AbstractEntityResource<ICGSTCategory> {
    constructor(igstCategoryService: IgstCategoryService, router: Router) {
        super(
            Resource.IN_IGST_RATES,
            igstCategoryService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.IN_IGST_RATES, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.IN_IGST_RATES),
            (entity?) => new IGSTCategory(entity),
            (entity) => entity.label,
            'attach_money'
        );
    }
}
